module.exports = __webpack_public_path__ + "static/media/icon-upload-disabled.817a26f2.svg";